import { render } from "./newSubmitView.vue?vue&type=template&id=b76826ec"
import script from "./newSubmitView.vue?vue&type=script&lang=js"
export * from "./newSubmitView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__